// extracted by mini-css-extract-plugin
export default {"contents":"aI-z","sectionHeading":"bI-z"};